import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";
import { EvaSubscriptionService } from "src/app/features/subscription/eva-subscription.service";

@Injectable({
  providedIn: "root",
})
export class TrialLandingGuard implements CanActivate {
  constructor(
    private evaSubscriptionService: EvaSubscriptionService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UrlTree> {
    if (!localStorage.getItem("evaJwt")) {
      return of(this.router.createUrlTree(["/login"]));
    }

    const incomingQuery = this.router.parseUrl(state.url).queryParams || {};

    return this.evaSubscriptionService.reloadSubscription().pipe(
      map((subscription) => {
        const isTrial = subscription?.status === "TRIAL";
        const target = isTrial ? "/getting-started" : "/home";
        const queryParams = isTrial ? incomingQuery : {};
        return this.router.createUrlTree([target], { queryParams });
      }),
      catchError(() => of(this.router.createUrlTree(["/home"]))),
    );
  }
}
